<template>
    <page-content bgClass="bg-#0E0E0E" :disablePullRefresh="true">
		<template v-slot:navBar>
			<home-nav :isHome="false" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div style="padding-bottom: 20px;">
				<div class="hqie">
					<div class="qieitem " :class="head==1?'qactive':''" @click="gethead(1)">{{$t("添加流动性")}}</div>
					<div class="qieitem" :class="head==2?'qactive':''" @click="gethead(2)">{{$t("我的池")}}</div>
				</div>
				<div class="daiview" v-if="head==1">
					<div class="daione">
						<span class="jiaoname">{{$t("交换代币")}}</span>
					</div>
					<div class="cong">
						<span class="congname">{{$t("从")}}</span>
						<span class="yue">{{$t("余额")}}  {{ from.balance }}</span>
					</div>
					<div class="jiaoone">
						<div class="jiaohead">
							<input class="jiaoshu" v-model="num" type="text" :placeholder="shuru" />
							<div class="jhrig" @click="openSelect('from')">
								<img :src="from.logo" class="icon_yth" alt="">
								<span class="jrname">{{ from.symbol }}</span>
								<img src="@/assets/images/new/icon_qh.png" class="icon_qh" alt="">
							</div>
						</div>
<!--						<span class="yudeng">≈$0.00</span>-->
					</div>
					<img src="@/assets/images/new/jia.png" class="jiaoimg" alt="">
					<div class="cong ctwo">
						<span class="congname">{{$t("至")}}</span>
						<span class="yue">{{$t("余额")}}  {{ to.balance }}</span>
					</div>
					<div class="jiaoone">
						<div class="jiaohead">
							<input class="jiaoshu" v-model="numTo" type="text" :placeholder="shuru" />
							<div class="jhrig" @click="openSelect('to')">
								<img :src="to.logo" class="icon_yth" alt="">
								<span class="jrname">{{ to.symbol }}</span>
								<img src="@/assets/images/new/icon_qh.png" class="icon_qh" alt="">
							</div>
						</div>
<!--						<span class="yudeng">≈$0.00</span>-->
					</div>
					<div class="feiview">
						<div class="feiitem">
							<span class="feileft">{{$t("池股份")}}</span>
							<span class="feirig">{{ poolSharePct }}%</span>
						</div>
<!--						<div class="feiitem">-->
<!--							<span class="feileft">{{$t("当前年利率")}}</span>-->
<!--							<span class="feirig bai">12.5%</span>-->
<!--						</div>-->
						<div class="feiitem">
							<span class="feileft">LP{{$t("代币")}}</span>
							<span class="feirig">{{ lpTokenBalance }}</span>
						</div>
					</div>
                    <div class="jdai" @click="addLiquidity">{{$t("添加流动性")}}</div>
				</div>
<!--				<div class="daiview daiviewtwo" v-if="head==1">-->
<!--					<div class="daione">-->
<!--						<span class="jiaoname">{{$t("热门池")}}</span>-->
<!--					</div>-->
<!--					<div class="jilistnew" v-for="(item,index) in 3" :key="index">-->
<!--						<img src="@/assets/images/new/nicon1.png" class="icon_ythicon" alt="">-->
<!--						<img src="@/assets/images/new/nicon2.png" class="icon_ythicon twoicon" alt="">-->
<!--						<div class="jinav">-->
<!--							<span class="jinavname ellipsis">1.5{{$t("以太坊")}} {{$t("兑换美元稳定币兑换")}}</span>-->
<!--							<span class="jinavtime">TVL:1.255{{$t("亿美元")}}</span>-->
<!--						</div>-->
<!--						<div class="jiright">-->
<!--							<span class="rshunew">12.5%</span>-->
<!--							<span class="rshunewyue">{{$t("四月")}}</span>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->

				<!-- 我的流动池 -->
                <div class="daiview daiviewtwo" v-if="head==2">
                    <div class="daione myliudong">
                        <span class="jiaoname">{{$t("我的流动池")}}</span>
                        <span class="zongji">{{$t("持有LP数")}}：{{ lpPositions.length }}</span>
                    </div>
                    <div v-if="lpPositions && lpPositions.length">
                        <div class="wchilist" v-for="(pos,idx) in lpPositions" :key="pos.pairAddress">
                            <div class="jilist">
                                <img :src="pos.tokenA.logo" class="icon_ythicon" alt="">
                                <img src="@/assets/images/new/jiaohuan.png" class="jiaohuan" alt="">
                                <img :src="pos.tokenB.logo" class="icon_ythicon" alt="">
                                <div class="jinav">
                                    <span class="jinavnametwo ellipsis">{{ pos.tokenA.symbol }}/{{ pos.tokenB.symbol }}</span>
                                    <span class="jinavtimetwo">{{$t("我的LP")}}：{{ pos.lpBalance }}</span>
                                </div>
                                <div class="jiright">
                                    <span class="rshunew">{{ pos.sharePct }}%</span>
                                    <span class="rshunewyue">{{$t("占比")}}</span>
                                </div>
                            </div>
                            <div class="yiview">
                                <div class="yiitem" @click="openRemoveModal(pos)">{{$t("移除")}}</div>
                                <div class="yiitem add" @click="gethead(1)">{{$t("添加更多")}}</div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="jilist">
                        <div class="jinav">
                            <span class="jinavname ellipsis">{{$t("暂无LP记录")}}</span>
                        </div>
                    </div>
                </div>
<!--				<div class="daiview daiviewtwo" v-if="head==2">-->
<!--					<div class="daione">-->
<!--						<span class="jiaoname">{{$t("热门池")}}</span>-->
<!--					</div>-->
<!--					<div class="mychi">-->
<!--						<span class="chiname">$125.50</span>-->
<!--						<span class="chimiao">{{$t("总薪酬")}}</span>-->
<!--						<div class="mychiitem">-->
<!--							<span class="mychiname">ETH/USDC{{$t("池")}}</span>-->
<!--							<span class="mychinum">$85.25</span>-->
<!--						</div>-->
<!--						<div class="mychiitem">-->
<!--							<span class="mychiname">USDC/USDT {{$t("交易池")}}</span>-->
<!--							<span class="mychinum">$85.25</span>-->
<!--						</div>-->
<!--						<div class="lingsuo">{{$t("领取所有奖励")}}</div>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</template>
		<template v-slot:menuBar>
		</template>
		<template v-slot:popup>
			<van-popup v-model="yichupop" position="center" @close="yichupop=false">
				<div class="yichupopview">
					<span class="yiname">{{$t("移除流动性")}}</span>
					<span class="yimiao">{{$t("确定要移除")}} {{ selectedLp ? (selectedLp.tokenA.symbol + '/' + selectedLp.tokenB.symbol + ' LP') : '' }} ？</span>
					<div class="popliu">
						<div class="popliuitem">
							<span class="mylname">{{$t("我的流动性")}}</span>
							<span class="mylval">{{ selectedLp ? selectedLp.lpBalance : '0' }}</span>
						</div>
					<div class="popliuitem">
						<span class="mylname">{{$t("占比")}}</span>
						<span class="mylval lv">{{ selectedLp ? (selectedLp.sharePct + '%') : '0%' }}</span>
					</div>
					</div>
					<div class="popbtn">
						<div class="btnqu" @click="yichupop=false">{{$t("取消")}}</div>
            <div class="btnqu quedin" @click="confirmRemoveLiquidity">{{$t("确认移除")}}</div>
					</div>
				</div>
			</van-popup>
			<van-popup v-model="selectpop" position="bottom" @close="selectpop=false">
				<div class="jiepopview">
					<div class="jieone">
						<span class="xname">{{$t("选择币种")}}</span>
						<img src="@/assets/images/new/icon_gb.png" @click="selectpop=false" class="icon_gb" alt="">
					</div>
					<div class="jipoplist" v-for="(item,idx) in trading_pair" :key="item.id" @click="chooseToken(item)" :class="(selectSide==='from' ? from.symbol : to.symbol)===item.symbol ? 'jipopactive' : ''">
						<img :src="item.logo" class="niconpop" alt="">
						<div class="dpopright">
							<div class="dpopone">
								<span class="popname">{{ item.symbol }}</span>
<!--								<span class="popname ml">{{ item.balance }}</span>-->
							</div>
							<div class="dpopone mt-two">
								<span class="popnametwo">{{ item.name }}</span>
								<span class="popnametwo ml">{{ item.contract_address ? item.contract_address.slice(0,6)+'...'+item.contract_address.slice(-4) : '' }}</span>
							</div>
						</div>
					</div>

				</div>

			</van-popup>
		</template>
	</page-content>
</template>

<script>
	import homeNav from '@/components/home-nav/home-nav.vue';
	import Web3 from 'web3';
    import {getShowAddress} from "@/libs/util";
    // Minimal ERC20 ABI: balance, decimals, symbol, allowance, approve
    const ERC20_ABI = [
        { constant: true, inputs: [{ name: 'account', type: 'address' }], name: 'balanceOf', outputs: [{ name: '', type: 'uint256' }], type: 'function' },
        { constant: true, inputs: [], name: 'totalSupply', outputs: [{ name: '', type: 'uint256' }], type: 'function' },
        { constant: true, inputs: [], name: 'decimals', outputs: [{ name: '', type: 'uint8' }], type: 'function' },
        { constant: true, inputs: [], name: 'symbol', outputs: [{ name: '', type: 'string' }], type: 'function' },
        { constant: true, inputs: [{ name: 'owner', type: 'address' }, { name: 'spender', type: 'address' }], name: 'allowance', outputs: [{ name: '', type: 'uint256' }], type: 'function' },
        { constant: false, inputs: [{ name: 'spender', type: 'address' }, { name: 'amount', type: 'uint256' }], name: 'approve', outputs: [{ name: '', type: 'bool' }], type: 'function' }
    ];
    // Minimal Router ABI: WETH, addLiquidity, addLiquidityETH
    const ROUTER_ABI = [
        { inputs: [], name: 'WETH', outputs: [{ internalType: 'address', name: '', type: 'address' }], stateMutability: 'view', type: 'function' },
        { inputs: [
            { internalType: 'address', name: 'tokenA', type: 'address' },
            { internalType: 'address', name: 'tokenB', type: 'address' },
            { internalType: 'uint256', name: 'amountADesired', type: 'uint256' },
            { internalType: 'uint256', name: 'amountBDesired', type: 'uint256' },
            { internalType: 'uint256', name: 'amountAMin', type: 'uint256' },
            { internalType: 'uint256', name: 'amountBMin', type: 'uint256' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'deadline', type: 'uint256' }
        ], name: 'addLiquidity', outputs: [
            { internalType: 'uint256', name: 'amountA', type: 'uint256' },
            { internalType: 'uint256', name: 'amountB', type: 'uint256' },
            { internalType: 'uint256', name: 'liquidity', type: 'uint256' }
        ], stateMutability: 'nonpayable', type: 'function' },
        { inputs: [
            { internalType: 'address', name: 'token', type: 'address' },
            { internalType: 'uint256', name: 'amountTokenDesired', type: 'uint256' },
            { internalType: 'uint256', name: 'amountTokenMin', type: 'uint256' },
            { internalType: 'uint256', name: 'amountETHMin', type: 'uint256' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'deadline', type: 'uint256' }
        ], name: 'addLiquidityETH', outputs: [
            { internalType: 'uint256', name: 'amountToken', type: 'uint256' },
            { internalType: 'uint256', name: 'amountETH', type: 'uint256' },
            { internalType: 'uint256', name: 'liquidity', type: 'uint256' }
        ], stateMutability: 'payable', type: 'function' },
        { inputs: [
            { internalType: 'address', name: 'tokenA', type: 'address' },
            { internalType: 'address', name: 'tokenB', type: 'address' },
            { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
            { internalType: 'uint256', name: 'amountAMin', type: 'uint256' },
            { internalType: 'uint256', name: 'amountBMin', type: 'uint256' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'deadline', type: 'uint256' }
        ], name: 'removeLiquidity', outputs: [
            { internalType: 'uint256', name: 'amountA', type: 'uint256' },
            { internalType: 'uint256', name: 'amountB', type: 'uint256' }
        ], stateMutability: 'nonpayable', type: 'function' },
        { inputs: [
            { internalType: 'address', name: 'token', type: 'address' },
            { internalType: 'uint256', name: 'liquidity', type: 'uint256' },
            { internalType: 'uint256', name: 'amountTokenMin', type: 'uint256' },
            { internalType: 'uint256', name: 'amountETHMin', type: 'uint256' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'deadline', type: 'uint256' }
        ], name: 'removeLiquidityETH', outputs: [
            { internalType: 'uint256', name: 'amountToken', type: 'uint256' },
            { internalType: 'uint256', name: 'amountETH', type: 'uint256' }
        ], stateMutability: 'nonpayable', type: 'function' }
    ];
    // Minimal Factory ABI for pair lookup
    const FACTORY_ABI = [
        { inputs: [
            { internalType: 'address', name: 'tokenA', type: 'address' },
            { internalType: 'address', name: 'tokenB', type: 'address' }
        ], name: 'getPair', outputs: [{ internalType: 'address', name: '', type: 'address' }], stateMutability: 'view', type: 'function' }
    ];
    // Minimal Pair ABI: reserves & token order
    const PAIR_ABI = [
        { constant: true, inputs: [], name: 'token0', outputs: [{ name: '', type: 'address' }], type: 'function' },
        { constant: true, inputs: [], name: 'token1', outputs: [{ name: '', type: 'address' }], type: 'function' },
        { constant: true, inputs: [], name: 'getReserves', outputs: [
            { name: 'reserve0', type: 'uint112' },
            { name: 'reserve1', type: 'uint112' },
            { name: 'blockTimestampLast', type: 'uint32' }
        ], type: 'function' }
    ];
    const ZERO_ADDR = '0x0000000000000000000000000000000000000000'
export default {
		components: {
			homeNav,
		},
        data() {
            return {
                num:0.00,
                numTo:0.00,
                ishua:false,
                shuzhi:1,
                web3Provider: null,
                web3: null,
                currentAccount: null,
                selectpop:false,
                selectSide:null,
                popbizhong:1,
                head:1,
                ROUTER_ADDRESS:"0xa54d92bEd6455E43a09f6315fD050edFA9997306",
                FACTORY_ADDRESS:"0xf4516EFf9b8F046E86B64FD6956dce0928296856",
                from:{
                    "contract_address":"",
                    "id":1,
                    "name":"ROON",
                    "balance":"0",
                    "symbol":"ROON",
                    // 通过 webpack 的 require 在数据里引入静态图片资源
                    "logo": require('@/assets/images/common/img_logo.png'),
                },
                to:{
                    "contract_address":"0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
                    "id":3,
                    "name":"USDR",
                    "balance":"0",
                    "symbol":"USDR",
                    // 通过 webpack 的 require 在数据里引入静态图片资源
                    "logo": require('@/assets/images/common/usdr.png'),
                },
                trading_pair: [
                    {
                        "contract_address":"",
                        "id":1,
                        "name":"ROON",
                        "balance":"0",
                        "symbol":"ROON",
                        // 通过 webpack 的 require 在数据里引入静态图片资源
                        "logo": require('@/assets/images/common/img_logo.png'),
                    },
                    // {
                    //     "contract_address":"0x85CBe6769368C83C1f82f8f65118D5A34c2Bf62a",
                    //     "id":2,
                    //     "name":"WROON",
                    //     "balance":"0",
                    //     "symbol":"WROON",
                    //     // 通过 webpack 的 require 在数据里引入静态图片资源
                    //     "logo": require('@/assets/images/common/img_logo.png'),
                    // },
                    {
                        "contract_address":"0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
                        "id":3,
                        "name":"USDR",
                        "balance":"0",
                        "symbol":"USDR",
                        // 通过 webpack 的 require 在数据里引入静态图片资源
                        "logo": require('@/assets/images/common/usdr.png'),
                    }
                ],
                yichupop:false,
                lpPositions:[],
                // 当前选中 from/to 组合的池占比与 LP 数量（用于 head==1 区域展示）
                poolSharePct: '0.00',
                lpTokenBalance: '0',
                // 当前 from/to 最新交易对价格（1 from = X to）
                swapPairPrice: null,
                // 输入联动更新的锁，避免循环触发：'num' 或 'numTo'
                updateLock: null,
                // 弹窗：当前选中的 LP 条目及预计取回的代币数量
                selectedLp: null,
                expectedWithdraw: { amountA: '0', amountB: '0', tokenA: '', tokenB: '' }
            };
        },
		computed: {
			shuru() {
				return this.$t("请输入");
			},
		},
        created() {
            getShowAddress()
            this.initWeb3().then(() => {
                this.refreshBalances();
                // 首次进入页面即计算并展示池股份与LP数量
                this.refreshPairShare && this.refreshPairShare()
                // 计算初始 from/to 的直连价格
                this.computeSwapPairPrice && this.computeSwapPairPrice()
                // 尝试加载 LP 记录（若钱包连接且在“我的池”）
                if (this.head === 2) this.loadUserLpPositions().catch(() => {})
            });

        },
        watch: {
            // 当 from 数量变化时，依据价格联动计算 to 数量
            num(newVal){
                try{
                    const vm = this
                    const priceStr = vm.swapPairPrice
                    if (!priceStr) return
                    // 若此变化源自 numTo 的联动更新，则跳过并清锁
                    if (vm.updateLock === 'numTo') { vm.updateLock = null; return }
                    vm.updateLock = 'num'
                    const price = Number(priceStr)
                    const a = Number(newVal)
                    if (isNaN(a)) {
                        vm.numTo = ''
                    } else {
                        const b = a * price
                        vm.numTo = Number.isFinite(b) ? b.toFixed(6) : ''
                    }
                    this.$nextTick(() => { vm.updateLock = null })
                }catch(_){ /* ignore */ }
            },
            // 当 to 数量变化时，依据价格联动计算 from 数量
            numTo(newVal){
                try{
                    const vm = this
                    const priceStr = vm.swapPairPrice
                    if (!priceStr) return
                    // 若此变化源自 num 的联动更新，则跳过并清锁
                    if (vm.updateLock === 'num') { vm.updateLock = null; return }
                    vm.updateLock = 'numTo'
                    const price = Number(priceStr)
                    const b = Number(newVal)
                    if (isNaN(b) || !Number.isFinite(price) || price === 0) {
                        vm.num = ''
                    } else {
                        const a = b / price
                        vm.num = Number.isFinite(a) ? a.toFixed(6) : ''
                    }
                    this.$nextTick(() => { vm.updateLock = null })
                }catch(_){ /* ignore */ }
            }
        },
        methods: {
			// ERC20 ABI（已在模块作用域定义），此方法保留兼容旧调用
			getERC20Abi(){
				return ERC20_ABI
			},
			// 计算基础单位（将十进制字符串转为整型基数，遵循 decimals）
			toBaseUnit(decimalStr, decimals){
				try{
					const vm = this
					const toBN = vm.web3.utils.toBN
					const d = Number(decimals || 0)
					const pow10 = (n) => toBN('1' + '0'.repeat(n))
					let s = String(decimalStr || '0')
					if (!s.includes('.')) return toBN(s).mul(pow10(d))
					const [intPart, fracRaw] = s.split('.')
					const frac = (fracRaw || '').slice(0, d)
					const intBN = toBN(intPart || '0').mul(pow10(d))
					const fracBN = frac ? toBN(frac).mul(pow10(d - frac.length)) : toBN('0')
					return intBN.add(fracBN)
				} catch(e){
					return this.web3.utils.toBN('0')
				}
			},
			async getTokenDecimals(addr){
				try{
					const c = new this.web3.eth.Contract(ERC20_ABI, addr)
					const d = await c.methods.decimals().call()
					return Number(d)
				}catch(_){ return 18 }
			},
			// 确保给路由的代币授权充足（兼容 USDT类先置0再授权）
            async ensureTokenAllowance(tokenAddress, owner, spender, requiredAmountBN) {
                const vm = this
                const toBN = vm.web3.utils.toBN
                const c = new vm.web3.eth.Contract(ERC20_ABI, tokenAddress)
                const gasPrice = await vm.web3.eth.getGasPrice()
                const addBuffer = (gas) => {
                    const g = toBN(gas)
                    return g.mul(toBN('120')).div(toBN('100'))
                }

                const current = await c.methods.allowance(owner, spender).call()
                if (toBN(current).gte(requiredAmountBN)) return

                // 先尝试直接授权 requiredAmount
                try {
                    const gas = await c.methods.approve(spender, requiredAmountBN.toString()).estimateGas({ from: owner })
                    await c.methods.approve(spender, requiredAmountBN.toString()).send({ from: owner, gasPrice, gas: addBuffer(gas).toString() })
                    return
                } catch (err) {
                    console.error('Direct approve failed, fallback to zero-reset then approve:', err && err.message || err)
                }

                // 置0再授权
                try {
                    const zeroGas = await c.methods.approve(spender, '0').estimateGas({ from: owner })
                    await c.methods.approve(spender, '0').send({ from: owner, gasPrice, gas: addBuffer(zeroGas).toString() })
                } catch (err) {
                    console.error('Approve zero failed:', err && err.message || err)
                    throw err
                }

                const gas = await c.methods.approve(spender, requiredAmountBN.toString()).estimateGas({ from: owner })
                await c.methods.approve(spender, requiredAmountBN.toString()).send({ from: owner, gasPrice, gas: addBuffer(gas).toString() })
            },
            // 打开移除弹窗，并计算预计取回的代币数量
            async openRemoveModal(pos){
                const vm = this
                try {
                    vm.selectedLp = pos
                    vm.yichupop = true
                    await vm.initWeb3()
                    const addr = vm.currentAccount
                    if (!addr || !pos || !pos.pairAddress) {
                        vm.expectedWithdraw = { amountA: '0', amountB: '0', tokenA: pos?.tokenA?.symbol || '', tokenB: pos?.tokenB?.symbol || '' }
                        return
                    }

                    // 读取储备与 LP 总量，计算按 LP 份额可取回的基础代币数量
                    const pair = new vm.web3.eth.Contract(PAIR_ABI, pos.pairAddress)
                    const lp = new vm.web3.eth.Contract(ERC20_ABI, pos.pairAddress)
                    let token0 = null, token1 = null, reserves = null, lpBalRaw = '0', totalRaw = '0'
                    try {
                        token0 = await pair.methods.token0().call()
                        token1 = await pair.methods.token1().call()
                        reserves = await pair.methods.getReserves().call()
                    } catch (_){ /* ignore */ }
                    try {
                        lpBalRaw = await lp.methods.balanceOf(addr).call()
                        totalRaw = await lp.methods.totalSupply().call()
                    } catch (_){ lpBalRaw = '0'; totalRaw = '0' }

                    const toBN = vm.web3.utils.toBN
                    if (!reserves || toBN(totalRaw).isZero()){
                        vm.expectedWithdraw = { amountA: '0', amountB: '0', tokenA: pos.tokenA.symbol, tokenB: pos.tokenB.symbol }
                        return
                    }

                    // 将储备与份额按 BN 比例计算
                    const r0 = toBN(reserves.reserve0 || '0')
                    const r1 = toBN(reserves.reserve1 || '0')
                    const shareNumer = toBN(lpBalRaw)
                    const shareDenom = toBN(totalRaw)
                    let amt0 = toBN('0'), amt1 = toBN('0')
                    try {
                        amt0 = r0.mul(shareNumer).div(shareDenom)
                        amt1 = r1.mul(shareNumer).div(shareDenom)
                    } catch (_){ amt0 = toBN('0'); amt1 = toBN('0') }

                    // 确定 tokenA/tokenB 与 token0/token1 的映射，并按各自 decimals 格式化
                    const Aaddr = pos.tokenA.address
                    const Baddr = pos.tokenB.address
                    const aDecimals = await vm.getTokenDecimals(Aaddr)
                    const bDecimals = await vm.getTokenDecimals(Baddr)

                    let amountA = '0', amountB = '0'
                    try {
                        if (String(Aaddr).toLowerCase() === String(token0).toLowerCase()){
                            amountA = vm.trimDecimals(vm.formatUnits(amt0.toString(), aDecimals))
                            amountB = vm.trimDecimals(vm.formatUnits(amt1.toString(), bDecimals))
                        } else {
                            amountA = vm.trimDecimals(vm.formatUnits(amt1.toString(), aDecimals))
                            amountB = vm.trimDecimals(vm.formatUnits(amt0.toString(), bDecimals))
                        }
                    } catch (_){ amountA = '0'; amountB = '0' }

                    vm.expectedWithdraw = { amountA, amountB, tokenA: pos.tokenA.symbol, tokenB: pos.tokenB.symbol }
                } catch (e){
                    console.error('openRemoveModal error', e)
                    vm.expectedWithdraw = { amountA: '0', amountB: '0', tokenA: pos?.tokenA?.symbol || '', tokenB: pos?.tokenB?.symbol || '' }
                }
            },
            // 确认移除：执行 removeLiquidity / removeLiquidityETH
            async confirmRemoveLiquidity(){
                const vm = this
                try{
                    await vm.initWeb3()
                    const web3 = vm.web3
                    // 网络校验：要求在 ROON 主网 (1492)
                    let currentChainId = null
                    try { currentChainId = await web3.eth.getChainId() } catch(_) { currentChainId = null }
                    if (currentChainId == null && window.ethereum && typeof window.ethereum.request === 'function'){
                        try {
                            const hex = await window.ethereum.request({ method: 'eth_chainId' })
                            currentChainId = typeof hex === 'string' ? parseInt(hex, 16) : Number(hex)
                        } catch(_) { currentChainId = null }
                    }
                    if (Number(currentChainId) !== 1492) { vm.$message && vm.$message.error('请先切换到ROON主网'); return }

                    const accounts = await web3.eth.getAccounts()
                    const addr = accounts && accounts[0]
                    if (!addr) { vm.$message && vm.$message.error('钱包未连接'); return }

                    const sel = vm.selectedLp
                    if (!sel || !sel.pairAddress) { vm.$message && vm.$message.error('未选择流动池'); return }

                    const router = new web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)
                    const WETH = await router.methods.WETH().call()

                    // 读取我的 LP 数量
                    const lp = new web3.eth.Contract(ERC20_ABI, sel.pairAddress)
                    const lpBalRaw = await lp.methods.balanceOf(addr).call()
                    const liquidityBN = web3.utils.toBN(lpBalRaw)
                    if (liquidityBN.isZero()) { vm.$message && vm.$message.error('无可移除的LP'); return }

                    // 授权 LP 给 Router
                    await vm.ensureTokenAllowance(sel.pairAddress, addr, vm.ROUTER_ADDRESS, liquidityBN)

                    const deadline = Math.floor(Date.now() / 1000) + 1200
                    const isETHPair = ((sel.tokenA.address || '').toLowerCase() === WETH.toLowerCase()) || ((sel.tokenB.address || '').toLowerCase() === WETH.toLowerCase())
                    const zero = '0'

                    let tx
                    if (isETHPair) {
                        const token = ((sel.tokenA.address || '').toLowerCase() === WETH.toLowerCase()) ? sel.tokenB.address : sel.tokenA.address
                        tx = router.methods.removeLiquidityETH(token, liquidityBN.toString(), zero, zero, addr, deadline)
                    } else {
                        tx = router.methods.removeLiquidity(sel.tokenA.address, sel.tokenB.address, liquidityBN.toString(), zero, zero, addr, deadline)
                    }

                    const gas = await tx.estimateGas({ from: addr })
                    const gasPrice = await web3.eth.getGasPrice()
                    const gasWithBuffer = web3.utils.toBN(gas).mul(web3.utils.toBN(120)).div(web3.utils.toBN(100)).toString()

                    await tx.send({ from: addr, gas: gasWithBuffer, gasPrice })

                    vm.$message && vm.$message.success('移除成功')
                    vm.yichupop = false

                    // 刷新相关数据
                    vm.refreshPairShare && (await vm.refreshPairShare())
                    vm.loadUserLpPositions && vm.loadUserLpPositions().catch(() => {})
                }catch(e){
                    console.error('confirmRemoveLiquidity error', e)
                    vm.$message && vm.$message.error(e?.message || '移除失败')
                }
            },
            async initWeb3(){
                try{
                    if (this.web3) return;
                    if (window.ethereum){
                        this.web3Provider = window.ethereum;
                        await window.ethereum.request({ method: 'eth_requestAccounts' });
                        this.web3 = new Web3(window.ethereum);
                        // 监听账户变化，自动刷新余额
                        window.ethereum.removeAllListeners && window.ethereum.removeAllListeners('accountsChanged')
                        window.ethereum.on && window.ethereum.on('accountsChanged', (accs) => {
                            this.currentAccount = accs && accs.length ? accs[0] : null
                            this.refreshBalances()
                            this.refreshPairShare()
                        })
                    } else if (window.web3){
                        this.web3Provider = window.web3.currentProvider;
                        this.web3 = new Web3(window.web3.currentProvider);
                    } else {
                        console.warn('No web3 provider found');
                    }
					let accounts = []
					if (window.ethereum && typeof window.ethereum.request === 'function') {
						accounts = await window.ethereum.request({ method: 'eth_accounts' })
					} else if (this.web3 && this.web3.eth && typeof this.web3.eth.getAccounts === 'function') {
						accounts = await this.web3.eth.getAccounts()
					}
					this.currentAccount = (accounts && accounts.length) ? accounts[0] : null;
                } catch(e){
                    console.error('initWeb3 error', e);
                }
            },
			formatUnits(value, decimals){
				try{
					value = value?.toString() || '0'
					decimals = Number(decimals || 0)
					const negative = value.startsWith('-')
					if (negative) value = value.slice(1)
					if (decimals === 0) return negative ? ('-' + value) : value
					const len = value.length
					const whole = len > decimals ? value.slice(0, len - decimals) : '0'
					let fraction = len > decimals ? value.slice(len - decimals) : value.padStart(decimals, '0')
					fraction = fraction.replace(/0+$/, '')
					const result = fraction ? `${whole}.${fraction}` : whole
					return negative ? ('-' + result) : result
				} catch(e){
					return '0'
				}
			},
			trimDecimals(str, n = 6){
				if (!str || typeof str !== 'string') return '0'
				if (!str.includes('.')) return str
				const [i, f] = str.split('.')
				return `${i}.${(f || '').slice(0, n)}`
			},
			async getMainBalance(address){
				try{
					if (!this.web3 || !address) return '0'
					const wei = await this.web3.eth.getBalance(address)
					const eth = this.web3.utils.fromWei(wei, 'ether')
					return this.trimDecimals(eth)
				}catch(e){
					console.error('getMainBalance error', e)
					return '0'
				}
			},
			async getTokenBalance(tokenAddress, address){
				try{
					if (!this.web3 || !tokenAddress || !address) return '0'
					const token = new this.web3.eth.Contract(ERC20_ABI, tokenAddress)
					const [balRaw, decimals] = await Promise.all([
						token.methods.balanceOf(address).call(),
						token.methods.decimals().call()
					])
					const formatted = this.formatUnits(balRaw, Number(decimals))
					return this.trimDecimals(formatted)
				}catch(e){
					console.error('getTokenBalance error', e)
					return '0'
				}
			},
            // 添加流动性（根据 from/to 判断主币对或代币对）
            async addLiquidity(){
                const vm = this
                try{
                    await vm.initWeb3()
                    const accounts = await vm.web3.eth.getAccounts()
                    const addr = accounts && accounts[0]
                    if (!addr) { vm.$message && vm.$message.error('钱包未连接'); return }

                    // 网络校验：要求在 ROON 主网 (chainId = 1492)
                    let currentChainId = null
                    try { currentChainId = await vm.web3.eth.getChainId() } catch(_) { currentChainId = null }
                    if (currentChainId == null && window.ethereum && typeof window.ethereum.request === 'function'){
                        try {
                            const hex = await window.ethereum.request({ method: 'eth_chainId' })
                            currentChainId = typeof hex === 'string' ? parseInt(hex, 16) : Number(hex)
                        } catch(_) { currentChainId = null }
                    }
                    if (Number(currentChainId) !== 1492) {
                        vm.$message && vm.$message.error('请先切换到ROON主网')
                        return
                    }

                    if (!vm.ROUTER_ADDRESS) { vm.$message && vm.$message.error('路由地址缺失'); return }
                    const router = new vm.web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)

                    const aStr = String(vm.num || '0')
                    const bStr = String(vm.numTo || '0')
                    if (!(Number(aStr) > 0 && Number(bStr) > 0)) { vm.$message && vm.$message.error('请输入有效的两侧数量'); return }

                const isA_Native = !vm.from.contract_address
                const isB_Native = !vm.to.contract_address
                const aDecimals = isA_Native ? 18 : await vm.getTokenDecimals(vm.from.contract_address)
                const bDecimals = isB_Native ? 18 : await vm.getTokenDecimals(vm.to.contract_address)
                const amountADesired = vm.toBaseUnit(aStr, aDecimals)
                const amountBDesired = vm.toBaseUnit(bStr, bDecimals)

                // 刷新池占比与 LP 数量（同步 UI）
                vm.refreshPairShare && vm.refreshPairShare()

                // 发送前余额充足校验（避免 RPC 报错）
                const toBN = vm.web3.utils.toBN
                if (isA_Native ^ isB_Native) {
                    // 主币-代币：校验主币余额与代币余额
                    const token = isA_Native ? vm.to.contract_address : vm.from.contract_address
                    const tokenSymbol = isA_Native ? vm.to.symbol : vm.from.symbol
                    const amountTokenDesired = isA_Native ? amountBDesired : amountADesired
                    const amountETHDesired = isA_Native ? amountADesired : amountBDesired

                    const erc20 = new vm.web3.eth.Contract(ERC20_ABI, token)
                    let tokenBalRaw = '0'
                    try { tokenBalRaw = await erc20.methods.balanceOf(addr).call() } catch(_) { tokenBalRaw = '0' }
                    if (toBN(tokenBalRaw).lt(amountTokenDesired)) {
                        vm.$message && vm.$message.error(`余额不足：${tokenSymbol}`)
                        return
                    }

                    let ethBalRaw = '0'
                    try { ethBalRaw = await vm.web3.eth.getBalance(addr) } catch(_) { ethBalRaw = '0' }
                    if (toBN(ethBalRaw).lt(amountETHDesired)) {
                        vm.$message && vm.$message.error('ROON余额不足')
                        return
                    }
                } else {
                    // 代币-代币：校验两侧代币余额
                    const tokenA = vm.from.contract_address
                    const tokenB = vm.to.contract_address
                    const erc20A = new vm.web3.eth.Contract(ERC20_ABI, tokenA)
                    const erc20B = new vm.web3.eth.Contract(ERC20_ABI, tokenB)
                    let balARaw = '0', balBRaw = '0'
                    try { balARaw = await erc20A.methods.balanceOf(addr).call() } catch(_) { balARaw = '0' }
                    try { balBRaw = await erc20B.methods.balanceOf(addr).call() } catch(_) { balBRaw = '0' }
                    if (toBN(balARaw).lt(amountADesired)) {
                        vm.$message && vm.$message.error(`余额不足：${vm.from.symbol}`)
                        return
                    }
                    if (toBN(balBRaw).lt(amountBDesired)) {
                        vm.$message && vm.$message.error(`余额不足：${vm.to.symbol}`)
                        return
                    }
                }

                // 滑点（沿用 NSwap 的映射）
                // 为避免因现有池子比例与用户输入不一致导致的回退，最小值设为0
                const amountAMin = toBN('0')
                const amountBMin = toBN('0')
                const deadline = Math.floor(Date.now()/1000) + 1800

                const gasPrice = await vm.web3.eth.getGasPrice()
                const addBuffer = (gas) => {
                    const g = toBN(gas)
                    return g.mul(toBN('120')).div(toBN('100'))
                }

                if (isA_Native ^ isB_Native) {
                    // 主币-代币对：使用 addLiquidityETH
                    const token = isA_Native ? vm.to.contract_address : vm.from.contract_address
                    const amountTokenDesired = isA_Native ? amountBDesired : amountADesired
                    const amountTokenMin = toBN('0')
                    const amountETHDesired = isA_Native ? amountADesired : amountBDesired
                    const amountETHMin = toBN('0')
                    // 代币侧授权
                    await vm.ensureTokenAllowance(token, addr, vm.ROUTER_ADDRESS, amountTokenDesired)
                    // 估算与发送
                    const gas = await router.methods.addLiquidityETH(
                        token,
                        amountTokenDesired.toString(),
                        amountTokenMin.toString(),
                        amountETHMin.toString(),
                        addr,
                        deadline
                    ).estimateGas({ from: addr, value: amountETHDesired.toString() })
                    await router.methods.addLiquidityETH(
                        token,
                        amountTokenDesired.toString(),
                        amountTokenMin.toString(),
                        amountETHMin.toString(),
                        addr,
                        deadline
                    ).send({ from: addr, value: amountETHDesired.toString(), gasPrice, gas: addBuffer(gas).toString() })
                } else {
                    // 代币-代币对：使用 addLiquidity
                    const tokenA = vm.from.contract_address
                    const tokenB = vm.to.contract_address
                    // 双侧授权
                    await vm.ensureTokenAllowance(tokenA, addr, vm.ROUTER_ADDRESS, amountADesired)
                    await vm.ensureTokenAllowance(tokenB, addr, vm.ROUTER_ADDRESS, amountBDesired)
                    // 估算与发送
                    const gas = await router.methods.addLiquidity(
                        tokenA,
                        tokenB,
                        amountADesired.toString(),
                        amountBDesired.toString(),
                        amountAMin.toString(),
                        amountBMin.toString(),
                        addr,
                        deadline
                    ).estimateGas({ from: addr })
                    await router.methods.addLiquidity(
                        tokenA,
                        tokenB,
                        amountADesired.toString(),
                        amountBDesired.toString(),
                        amountAMin.toString(),
                        amountBMin.toString(),
                        addr,
                        deadline
                    ).send({ from: addr, gasPrice, gas: addBuffer(gas).toString() })
                }

                    vm.$message && vm.$message.success(vm.$t("吐司.添加流动性成功"))
                    await vm.refreshBalances()
                    await vm.refreshPairShare && vm.refreshPairShare()
                    // 成功后重置输入框为默认 0，并暂时置空价格以避免联动改写
                    const prevPrice = vm.swapPairPrice
                    vm.swapPairPrice = null
                    vm.num = '0'
                    vm.numTo = '0'
                    vm.$nextTick(() => { vm.swapPairPrice = prevPrice })
                } catch(e){
                    const original = e?.data?.originalError?.message || e?.data?.message || e?.message
                    console.error('addLiquidity error', e)
                    vm.$message && vm.$message.error(original || '添加流动性失败')
                }
            },
            // 统计当前 from/to 组合的 LP 数量与我的池股份，更新 head==1 的展示
            async refreshPairShare(){
                const vm = this
                try{
                    await vm.initWeb3()
                    const addr = vm.currentAccount
                    if (!addr) { vm.poolSharePct = '0.00'; vm.lpTokenBalance = '0'; return }
                    if (!vm.ROUTER_ADDRESS || !vm.FACTORY_ADDRESS) { vm.poolSharePct = '0.00'; vm.lpTokenBalance = '0'; return }

                    const router = new vm.web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)
                    let WETH = null
                    try { WETH = await router.methods.WETH().call() } catch(_) { WETH = null }

                    const tokenA = vm.from.contract_address || WETH || null
                    const tokenB = vm.to.contract_address || WETH || null
                    if (!tokenA || !tokenB || tokenA === '0x' || tokenB === '0x') { vm.poolSharePct = '0.00'; vm.lpTokenBalance = '0'; return }

                    const factory = new vm.web3.eth.Contract(FACTORY_ABI, vm.FACTORY_ADDRESS)
                    let pairAddr = ZERO_ADDR
                    try { pairAddr = await factory.methods.getPair(tokenA, tokenB).call() } catch(_){ pairAddr = ZERO_ADDR }
                    if (!pairAddr || pairAddr === ZERO_ADDR) { vm.poolSharePct = '0.00'; vm.lpTokenBalance = '0'; return }

                    const lp = new vm.web3.eth.Contract(ERC20_ABI, pairAddr)
                    let balRaw = '0', totalRaw = '0', decimalsRaw = '18'
                    try {
                        balRaw = await lp.methods.balanceOf(addr).call()
                        totalRaw = await lp.methods.totalSupply().call()
                        decimalsRaw = await lp.methods.decimals().call()
                    } catch(_){ /* ignore */ }

                    // LP 数量格式化展示
                    const lpFormatted = vm.formatUnits(balRaw, Number(decimalsRaw))
                    vm.lpTokenBalance = vm.trimDecimals(lpFormatted)

                    // 股份百分比（整数 BN 计算，保留两位小数）
                    const toBN = vm.web3.utils.toBN
                    let pctStr = '0.00'
                    try {
                        if (toBN(totalRaw).gt(toBN('0'))){
                            const scaled = toBN(balRaw).mul(toBN('10000')).div(toBN(totalRaw)) // x100 with 2 decimals
                            const whole = scaled.div(toBN('100')).toString()
                            const frac = scaled.mod(toBN('100')).toString().padStart(2, '0')
                            pctStr = `${whole}.${frac}`
                        }
                    } catch(_){ pctStr = '0.00' }
                    vm.poolSharePct = pctStr
                } catch(e){
                    console.error('refreshPairShare error', e)
                    vm.poolSharePct = '0.00'
                    vm.lpTokenBalance = '0'
                }
            },
            async refreshBalances(){
                try{
                    await this.initWeb3()
                    if (!this.currentAccount) return
					// from 余额
					if (!this.from.contract_address){
						this.from.balance = await this.getMainBalance(this.currentAccount)
					} else {
						this.from.balance = await this.getTokenBalance(this.from.contract_address, this.currentAccount)
					}
					// to 余额
					if (!this.to.contract_address){
						this.to.balance = await this.getMainBalance(this.currentAccount)
					} else {
						this.to.balance = await this.getTokenBalance(this.to.contract_address, this.currentAccount)
					}
                }catch(e){
                    console.error('refreshBalances error', e)
                }
            },
            // 加载用户 LP 记录：遍历当前交易对列表的组合，查询工厂拿到 Pair 地址，再查 LP 余额与占比
            async loadUserLpPositions(){
                const vm = this
                try{
                    await vm.initWeb3()
                    const addr = vm.currentAccount
                    if (!addr) return
                    if (!vm.ROUTER_ADDRESS || !vm.FACTORY_ADDRESS) return
                    const router = new vm.web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)
                    const factory = new vm.web3.eth.Contract(FACTORY_ABI, vm.FACTORY_ADDRESS)

                    // 获取 WETH/WROON 地址以替代本地主币参与配对
                    let WETH = null
                    try { WETH = await router.methods.WETH().call() } catch(_) { WETH = null }

                    // 组装所有 token 组合（两两组合）
                    const tokens = vm.trading_pair.map(t => ({
                        address: t.contract_address || (WETH || '0x'),
                        symbol: t.symbol,
                        name: t.name,
                        logo: t.logo
                    })).filter(x => x.address && x.address !== '0x')

                    const positions = []
                    for (let i=0; i<tokens.length; i++){
                        for (let j=i+1; j<tokens.length; j++){
                            const A = tokens[i]
                            const B = tokens[j]
                            let pairAddr = ZERO_ADDR
                            try { pairAddr = await factory.methods.getPair(A.address, B.address).call() } catch(_){ pairAddr = ZERO_ADDR }
                            if (!pairAddr || pairAddr === ZERO_ADDR) continue
                            // LP 代币是标准 ERC20，可读余额/decimals/totalSupply
                            const lp = new vm.web3.eth.Contract(ERC20_ABI, pairAddr)
                            let [balRaw, decimalsRaw, totalRaw] = ['0','18','0']
                            try {
                                balRaw = await lp.methods.balanceOf(addr).call()
                                decimalsRaw = await lp.methods.decimals().call()
                            } catch(_){/* ignore */}
                            try { totalRaw = await lp.methods.totalSupply().call() } catch(_){ totalRaw = '0' }
                            const dec = Number(decimalsRaw||18)
                            const bal = vm.formatUnits(balRaw, dec)
                            const total = vm.formatUnits(totalRaw, dec)
                            const balF = vm.trimDecimals(bal, 6)
                            const totalF = vm.trimDecimals(total, 6)
                            const sharePct = (Number(totalF) > 0) ? ((Number(balF)/Number(totalF))*100).toFixed(4) : '0.0000'
                            if (Number(balF) <= 0) continue
                            positions.push({
                                pairAddress: pairAddr,
                                tokenA: A,
                                tokenB: B,
                                lpBalance: balF,
                                totalSupply: totalF,
                                sharePct
                            })
                        }
                    }
                    vm.lpPositions = positions
                }catch(e){
                    console.error('loadUserLpPositions error', e)
                }
            },
            async goToUniswapAddLiquidity(){
                try{
					const toChecksum = (addr) => {
						try {
							return this.web3?.utils?.toChecksumAddress ? this.web3.utils.toChecksumAddress(addr) : addr;
						} catch (_) {
							return addr;
						}
					};

					const nativeSymbol = 'ETH';
					const a = (this.from && this.from.contract_address) ? toChecksum(this.from.contract_address) : nativeSymbol;
					const b = (this.to && this.to.contract_address) ? toChecksum(this.to.contract_address) : nativeSymbol;

					// 获取链信息，尽量映射到 Uniswap 识别的 chain 名称
					let chainName = 'mainnet';
					try {
						let chainIdHex = null;
						if (window.ethereum && window.ethereum.request) {
							chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
						} else if (this.web3 && this.web3.eth && typeof this.web3.eth.getChainId === 'function') {
							const cid = await this.web3.eth.getChainId();
							chainIdHex = '0x' + Number(cid).toString(16);
						}
						const toDec = (hex) => {
							if (!hex) return null;
							try { return parseInt(hex, 16); } catch (_) { return null; }
						};
						const decId = toDec(chainIdHex);
						if (decId === 1) chainName = 'mainnet';
						else if (decId === 5) chainName = 'goerli';
						else if (decId === 11155111) chainName = 'sepolia';
						// 其它网络可能不被 Uniswap 官方站点支持，保持默认 mainnet
					} catch (_) {
						// 保持默认 mainnet
					}

					// 构造 Uniswap 添加流动性的 URL（v2 路由更通用）
					const url = `https://app.uniswap.org/#/add/v2/${a}/${b}?chain=${chainName}`;
					window.open(url, '_blank');
				} catch (err) {
					console.error('goToUniswapAddLiquidity error', err);
				}
			},
            openSelect(side){
                this.selectSide = side
                this.selectpop = true
            },
            async chooseToken(item){
                if(this.selectSide === 'from'){
                    this.from = { ...item }
                }else if(this.selectSide === 'to'){
                    this.to = { ...item }
                }
                this.selectpop = false
                this.selectSide = null
                this.refreshBalances()
                this.refreshPairShare && this.refreshPairShare()
                // 选择币种后，计算并记录当前 from/to 的最新 swap 价格
                try {
                    await this.computeSwapPairPrice()
                } catch (e) {
                    console.error('computeSwapPairPrice after chooseToken error', e)
                }
            },
            // 计算当前 from/to 的直连交易对价格：1 from = X to
            async computeSwapPairPrice(){
                const vm = this
                try{
                    if (!vm.web3) {
                        if (window.ethereum) {
                            vm.web3Provider = window.ethereum
                            vm.web3 = new Web3(vm.web3Provider)
                        } else {
                            vm.swapPairPrice = null
                            return
                        }
                    }
                    if (!vm.FACTORY_ADDRESS) { vm.swapPairPrice = null; return }

                    const toBN = vm.web3.utils.toBN
                    const ZERO = '0x0000000000000000000000000000000000000000'
                    const router = new vm.web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)
                    let WETH = null
                    try { WETH = await router.methods.WETH().call() } catch (_) { WETH = null }

                    const fromAddr = vm.from && vm.from.contract_address ? vm.from.contract_address : (WETH || ZERO)
                    const toAddr = vm.to && vm.to.contract_address ? vm.to.contract_address : (WETH || ZERO)

                    if (!fromAddr || !toAddr || fromAddr === ZERO || toAddr === ZERO) {
                        vm.swapPairPrice = null
                        return
                    }
                    if (fromAddr.toLowerCase() === toAddr.toLowerCase()) {
                        vm.swapPairPrice = '1.000000'
                        return
                    }

                    const factory = new vm.web3.eth.Contract(FACTORY_ABI, vm.FACTORY_ADDRESS)
                    const pairAddress = await factory.methods.getPair(fromAddr, toAddr).call()
                    if (!pairAddress || String(pairAddress).toLowerCase() === ZERO.toLowerCase()) {
                        vm.swapPairPrice = null
                        return
                    }

                    const pair = new vm.web3.eth.Contract(PAIR_ABI, pairAddress)
                    const token0 = await pair.methods.token0().call()
                    const token1 = await pair.methods.token1().call()
                    const { reserve0, reserve1 } = await pair.methods.getReserves().call()

                    // 读取 decimals（主币/WETH 默认 18）
                    const fromDecimals = vm.from && vm.from.contract_address ? await vm.getTokenDecimals(vm.from.contract_address) : 18
                    const toDecimals = vm.to && vm.to.contract_address ? await vm.getTokenDecimals(vm.to.contract_address) : 18

                    // 计算中间价（不含手续费折算），并做 decimals 调整
                    const r0 = toBN(reserve0)
                    const r1 = toBN(reserve1)
                    const fIs0 = fromAddr.toLowerCase() === token0.toLowerCase()
                    const tIs1 = toAddr.toLowerCase() === token1.toLowerCase()
                    const fIs1 = fromAddr.toLowerCase() === token1.toLowerCase()
                    const tIs0 = toAddr.toLowerCase() === token0.toLowerCase()

                    let price = null
                    const pow = (n) => {
                        try { return Math.pow(10, n) } catch(_) { return 1 }
                    }
                    const safeDiv = (aStr, bStr) => {
                        const a = Number(aStr)
                        const b = Number(bStr)
                        if (!b || !isFinite(a) || !isFinite(b)) return 0
                        return a / b
                    }

                    if (fIs0 && tIs1) {
                        // price = reserve1/reserve0 * 10^(fromDec - toDec)
                        const ratio = safeDiv(r1.toString(), r0.toString())
                        price = ratio * pow(fromDecimals - toDecimals)
                    } else if (fIs1 && tIs0) {
                        // price = reserve0/reserve1 * 10^(fromDec - toDec)
                        const ratio = safeDiv(r0.toString(), r1.toString())
                        price = ratio * pow(fromDecimals - toDecimals)
                    } else {
                        // 异常情况（地址不匹配），置空
                        vm.swapPairPrice = null
                        return
                    }

                    if (price === null || !isFinite(price)) {
                        vm.swapPairPrice = null
                        return
                    }
                    vm.swapPairPrice = Number(price).toFixed(6)
                }catch(e){
                    console.error('computeSwapPairPrice error', e)
                    vm.swapPairPrice = null
                }
            },
			getshuzhi(e){
				this.shuzhi = e
			},
            gethead(e){
                this.head = e
                // 切换到“我的池”时刷新 LP 记录
                if (e === 2) this.loadUserLpPositions && this.loadUserLpPositions()
                // 切换到“添加流动性”时刷新当前组合的池占比与 LP
                if (e === 1) this.refreshPairShare && this.refreshPairShare()
            }
        },
    };
</script>

<style scoped >
	.daiview{
		background: #19191A;
		border-radius: 10px;
		padding: 15px 15px 17px;
		margin:5px 15px;
	}
	.daione{
		display: flex;
		flex-direction: row;
		align-items: center;

	}
	.daione .zongji{
		position: relative;
		top: -1px;
	}
	.myliudong{
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		margin-bottom: 38px !important;
	}
	.jiaoname{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
	}

	.icon_sz{
		width: 19px;
		height: 20px;
		margin-left: auto;
	}
	.cong{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 20px 0 9px;
	}
	.congname{
		font-weight: 500;
		font-size: 12px;
		color: #999999;
	}
	.yue{
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		margin-left: auto;
	}
	.jiaoone{
		background: #0F0F10;
		border-radius: 10px;
		padding: 10px 10px 10px 15px;
		display: flex;
		flex-direction: column;
	}
	.jiaohead{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.jiaoshu{
		font-weight: bold;
		font-size: 20px;
		color: #FFFFFF;
		width: 57%;
	}

	.jhrig{
		margin-left: auto;
		padding: 8px 10px;
		background: rgba(255, 255, 255,0.2);
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.icon_yth{
		margin-right: 3px;
		width: 22px;
		height: 22px;
	}
	.icon_qh{
		margin-left: 10px;
		width: 11px;
		height: 11px;
	}
	.jrname{
		font-weight: bold;
		font-size: 20px;
		color: #FFFFFF;
	}
	.yudeng{
		font-weight: bold;
		font-size: 15px;
		color: #CCCCCC;
		display: block;
		margin-top: 12px;
	}
	.jiaoimg{
		width: 80px;
		height: 80px;
		margin: 0 auto;
		display: block;
	}
	.ctwo{
		margin-top: 0;
	}
	.feiview{
		padding: 15px;
		background: #3B1F15;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		margin-top: 15px;
	}
	.feiitem{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 10px;
	}
	.feiitem:last-child{
		margin-bottom: 0;
	}
	.feileft{
		font-weight: 500;
		font-size: 12px;
		color: #CCCCCC;
	}
	.feirig{
		margin-left: auto;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
	}
	.bai{
		color: #EB470C;
	}
	.jdai{
		margin: 20px 0 15px;
		height: 50px;
		background: #EB470C;
		border-radius: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.daiviewtwo{
		margin-top: 15px;
	}

	.jilist{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 14px;
	}
	.jilist:last-child{
		margin-bottom: 0;
	}
	.jilistnew{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 14px;
		background: #262626;
		border-radius: 10px;
		padding: 10px 15px;
	}
	.jilistnew:last-child{
		margin-bottom: 0;
	}
	.icon_ythicon{
		width: 30px;
		height: 30px;
	}
	.twoicon{
		position: relative;
		left: -10px;
		z-index: 1;
	}
	.jiaohuan{
		width: 10px;
		height: 10px;
		margin: 0 10px;
	}
	.daiviewtwo .daione{
		margin-bottom: 15px;
	}
	.jinav{
		display: flex;
		flex-direction: column;
		margin-left: 9px;
		width: 66%;
	}
	.jinavname{
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
	}
	.jinavtime{
		font-weight: 500;
		font-size: 10px;
		display: inline-block;
		margin-top: 5px;
		color: #999999;
		width: 100%;
	}
	.jinavnametwo{
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
	}
	.jinavtimetwo{
		font-weight: 500;
		font-size: 10px;
		display: inline-block;
		margin-top: 5px;
		color: #fff;
		width: 100%;
	}
	.jiright{
		margin-left: auto;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	.rshunew{
		font-weight: 500;
		font-size: 12px;
		color: #18E72B;
	}
	.rshunewyue{
		font-weight: 400;
		font-size: 9px;
		color: #999999;
		display: block;
		margin-top: 5px;
	}
	.ztai{
		padding: 5px 8px;
		background: #34CE5F;
		border-radius: 5px;
		font-weight: 500;
		font-size: 10px;
		color: #FFFFFF;
	}
	.dai{
		background: #CE7934;
	}
	/* 核心代码 */
	.ellipsis {
		white-space: nowrap; /* 强制文本不换行 */
		overflow: hidden;    /* 隐藏超出容器的内容 */
		text-overflow: ellipsis; /* 超出部分显示省略号（...） */
	}
	.huaview{
		height: 40px;
		background: #262626;
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 15px;
	}
	.huaname{
		font-weight: bold;
		font-size: 13px;
		color: #CCCCCC;
		display: inline-block;
		margin-left: 15px;
	}
	.huaright{
		display: flex;
		flex-direction: row;
		margin-left: auto;
		align-items: center;
		height: 100%;

	}
	.huaitem{
		min-width: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 13px;
		color: #FFFFFF;
		height: 100%;
	}
	.hactive{
		background: #EB470C;
		border-radius: 10px;
	}

	.jiepopview{
		background: #19191A;
		border-radius: 15px 15px 0px 0px;
		padding: 20px;
	}
	.jieone{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-bottom: 22px;
	}
	.xname{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
	}
	.icon_gb{
		width: 16px;
		height: 16px;
		position: absolute;
		right: 15px;
		top: 20px;
	}
	.jipoplist{
		background: #0F0F10;
		border-radius: 10px;
		padding: 15px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 12px;

	}
	.niconpop{
		margin-right: 10px;
		width: 30px;
		height: 30px;

	}
	.dpopright{
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		width: 83%;
	}
	.dpopone{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.popname{
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.popname{
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.ml{
		margin-left: auto;
	}
	.popnametwo{
		font-weight: 400;
		font-size: 12px;
		color: #CCCCCC;
	}
	.mt-two{
		margin-top: 4px;
	}
	.jipopactive{
		background: #3B1F15;
		border-radius: 10px;
		border: 1px solid #EB470C;
	}
	.hqie{
		height: 45px;
		background: #262626;
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		margin: 10px 15px 15px;
	}
	.qieitem{
		width: 50%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
		border-radius: 10px;
	}
	.qactive{
		background: #EB470C;
	}
	.zongji{
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		margin-left: auto;
	}
	.wchilist{
		padding:13px 15px 20px;
		background: #0F0F10;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		margin-bottom: 15px;
	}
	.wchilist:last-child{
		margin-bottom: 0;
	}
	.wchione{
		display: flex;
		flex-direction: row;
	}

	.wanglist{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin-bottom: 20px;
		/* margin-top: 15px; */
	}
	.wangitem{
		width: 48%;
		padding: 15px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		background: #282828;
		border-radius: 10px;
	}
	.wangicon{
		width: 35px;
		height: 35px;
		margin-right: 6px;
	}
	.wangright{
		display: flex;
		flex-direction: column;
	}
	.yitai{
		font-weight: 500;
		font-size: 10px;
		color: #CCCCCC;
	}
	.yitaimiao{
		font-weight: bold;
		font-size: 14px;
		color: #FFFFFF;
		display: block;
		margin-top: 5px;
	}
	.wangitem:nth-child(even){
		margin-left: auto;
	}
	.yiview{
		display: flex;
		flex-direction: row;
	}
	.yiitem{
		width: 48%;
		background: rgba(235, 12, 12,0.1);
		height: 40px;
		border-radius: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 16px;
		color: #EB0C0C;
	}
	.add{
		background: #EB470C;
		margin-left: auto;
		color: #FFFFFF;
	}
	.mychi{
		background: #262626;
		border-radius: 10px;
		padding: 15px;
		display: flex;
		flex-direction: column;
	}
	.chiname{
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
	}
	.chimiao{
		font-weight: 400;
		font-size: 9px;
		display: block;
		margin: 5px 0;
		color: #999999;
	}
	.mychiitem{
		display: flex;
		flex-direction: row;
		width: 100%;
		margin-bottom: 14px;

	}
	.mychiitem:last-child{
		margin-bottom: 0;
	}
	.mychiname{
		font-weight: 400;
		font-size: 12px;
		color: #CCCCCC;
	}
	.mychinum{
		margin-left: auto;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
	}
	.lingsuo{
		display: flex;
		align-items: center;
		justify-content: center;
		height: 50px;
		background: #EB470C;
		border-radius: 25px;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.yichupopview{
		width:350px;
		padding: 20px;
		background: #19191A;
		border-radius: 15px;

	}
	.yiname{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
		display: block;
		text-align: center;
	}
	.yimiao{
		display: block;
		text-align: center;
		font-weight: 400;
		font-size: 13px;
		color: #999999;
		margin: 15px 0;

	}
	.popliu{
		background: #0F0F10;
		border-radius: 10px;
		padding: 15px;
		display: flex;
		flex-direction: column;
	}
	.popliuitem{
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 15px;
	}
	.popliuitem:last-child{
		margin-bottom: 0;
	}
	.mylname{
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
	}
	.mylval{
		margin-left: auto;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
	}
	.lv{
		color: #18E72B;
	}
	.popbtn{
		display: flex;
		flex-direction: row;
		margin-top: 20px;
		align-items: center;
	}
	.btnqu{
		width: 48%;
		background: #333333;
		border-radius: 50px;
		height: 40px;
		font-weight: bold;
		font-size: 16px;
		color: #CCCCCC;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.quedin{
		margin-left: auto;
		background: #EB0C0C;
		color: #fff;
	}
</style>
